import {
  Button,
  Modal,
  MODAL_SIZE_MD,
  ModalBody,
  ModalFoot,
  ModalHead
} from 'mailup-web-components'
import { modalUsedMessageState } from 'Pages/Task/recoil/state/modals'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { useSetRecoilState } from 'recoil'

export const ModalStepMessageUsed = ({ show, handleConfirm, name }) => {
  const intl = useIntl()

  const setModalState = useSetRecoilState(modalUsedMessageState)

  const handleClose = () => {
    // chiudo questa modale
    setModalState((prev) => ({
      ...prev,
      show: false
    }))
  }

  return (
    <Modal
      data-mu-test='modal-endStepThirdWorkflow'
      show={show}
      showClose
      onClose={handleClose}
      closeOnOverlayClick
      size={MODAL_SIZE_MD}
    >
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.TriggersDetail.WarningSelectMessageTitle'
        })}
      />
      <ModalBody>
        <p>
          {intl.formatMessage({
            id: 'Load.TriggersDetail.WarningSelectMessage'
          })}
          {` (${name})`}
        </p>
      </ModalBody>
      <ModalFoot>
        <Button
          kind='secondary'
          onClick={handleClose}
          data-mu-test='button-cancel'
        >
          {intl.formatMessage({ id: 'Load.MailupCommon.SelectAnotherMessage' })}
        </Button>
        <Button
          kind='primary'
          onClick={handleConfirm}
          data-mu-test='button-confirm'
        >
          {intl.formatMessage({
            id: 'Load.MailupCommon.CreateCopy'
          })}
        </Button>
      </ModalFoot>
    </Modal>
  )
}

ModalStepMessageUsed.propTypes = {
  show: PropTypes.bool,
  handleConfirm: PropTypes.func,
  name: PropTypes.string
}
